const images = [
  { src: require("./sc1.svg").default, alt: "showcase-1" },
  { src: require("./sc2.svg").default, alt: "showcase-2" },
  { src: require("./sc3.svg").default, alt: "showcase-3" },
  { src: require("./sc4.svg").default, alt: "showcase-4" },
  { src: require("./sc5.svg").default, alt: "showcase-5" },
  { src: require("./sc6.svg").default, alt: "showcase-6" },
  { src: require("./sc7.svg").default, alt: "showcase-7" },
  { src: require("./sc8.svg").default, alt: "showcase-8" },
];

export default images;
